import { ApplicationLanding } from './ApplicationLanding';
export { ApplicationLanding };
